import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { getProtectedResource } from "../../services/apiRequest.service";
import { NestedResponseData } from "../../models/responseData";
import {
  TransformedData,
  transformDataBarChart
} from "../../utils/transformDataUtils";
import FilterDropdown from "../../components/FilterDropdown";
import InstitutionN from "../../components/InstitutionN";
import DoubleBarChart from "../../charts/doubleBarChart/DoubleBarChart";
import PageLoader from "../../components/PageLoader";
import ApiResponseToCSVConverter from "../../utils/csvDownload/ApiResponseToCsvConverter";
import { determineResponseTypeNestedResponseData } from "../../utils/determineResponseType";


const Likelihood = () => {
  const [selectedFilter, setSelectedFilter] = useState("exit_status");
  const [apiResponse, setApiResponse] = useState<NestedResponseData | null>(null);
  const [transformedResponse, setTransformedResponse] = useState<TransformedData[] | null>(null);
  const [institutionN, setInstitutionN] = useState(0);

  const { getAccessTokenSilently } = useAuth0();
  const { year } = useParams();

  useEffect(() => {
    const getData = async () => {
      const accessToken = await getAccessTokenSilently();
      const requestUrl = `section9/subsection1/?report_year=${year}&group_by=${selectedFilter}`;
      const { data, error } = await getProtectedResource(accessToken, requestUrl);

      if (data && determineResponseTypeNestedResponseData(data)) {
        setApiResponse(data);
        setTransformedResponse(transformDataBarChart(data, "9.1", selectedFilter));
        if (data.institution.preemptive_retention) {
          setInstitutionN(data.institution.preemptive_retention.total);
        }
      }

      if (error) {
        console.error("Error fetching data:", error);
      }
    };

    getData();
  }, [getAccessTokenSilently, year, selectedFilter]);

  return (
    <>
      <h2>9.1 Proposed changes</h2>
      <p>
        Which of the following statements describe the recent changes made to your work or employment at your institution? Mark all that apply.
      </p>
      <p>
        Note: This question is only asked of preemptive retentions.
      </p>

      {!transformedResponse && <PageLoader />}

      {transformedResponse &&
        <>
          <InstitutionN institutionN={institutionN} />
          <FilterDropdown setSelectedFilter={setSelectedFilter} />
          <DoubleBarChart
            data={transformedResponse}
            selectedFilter={selectedFilter}
            institutionN={institutionN}
            section="9.1"
          />
          <ApiResponseToCSVConverter
            apiResponse={apiResponse}
            selectedFilter={selectedFilter}
            filename="9.1_Proposed_changes"
            section="9.1"
          />
        </>
      }


    </>
  )
}

export default Likelihood;